import { match } from 'ts-pattern';

import {
  AuthorizeSigningRequestProvider,
  useAuthorizeSigningRequest,
} from '@/providers';
import { Loading } from '@infinex-private/connect-web-shared/components';

import { SignMessage } from './components/SignMessage';
import { SignTransaction } from './components/SignTransaction';

function AuthorizeSigningRequestContent() {
  const { metadata, isLoadingOptions } = useAuthorizeSigningRequest();

  if (isLoadingOptions) {
    return <Loading />;
  }

  return match(metadata?.input?.type)
    .with('evm:message', 'evm:typedDataV4', 'svm:signMessage', () => (
      <SignMessage />
    ))
    .with(
      'evm:userOperation',
      'evm:transaction',
      'svm:transaction',
      'svm:batchTransactions',
      () => <SignTransaction />
    )
    .otherwise(() => <div>Unknown request type</div>);
}

export default function AuthorizeSigningRequestPage() {
  return (
    <AuthorizeSigningRequestProvider>
      <AuthorizeSigningRequestContent />
    </AuthorizeSigningRequestProvider>
  );
}
